// external imports
import React from 'react'
import { BooleanState } from 'quark-web'
// local imports
import { Text } from '~/components'
import styles from './styles'
import Indicator from './Indicator'

const Accordion = ({ title, startActive, children }) => (
    <BooleanState initial={startActive}>
        {({ state, toggle }) => (
            <React.Fragment>
                <div onClick={toggle} style={styles.toggle}>
                    <Indicator active={state} />
                    <Text style={state ? styles.titleActive : styles.titleInactive}>{title}</Text>
                </div>
                {state && <div style={styles.content}>{children}</div>}
            </React.Fragment>
        )}
    </BooleanState>
)

export default Accordion



// WEBPACK FOOTER //
// ./src/components/Accordion/index.js